<template>
    <div>
        <h3 class="text-lg font-medium text-gray-900 mb-5">
            Limites de Transações
        </h3>
        <div v-for="(limit, key) in form.limits" v-bind:key="key" :id="key">
            <jet-form-section
                icon="fa-comments-dollar"
                cols="grid-cols-1"
                :ref="key"
                class="mb-2">
                <template #title>
                    {{ `${limit[0].type.name} ${limit[0].destination.name}` }}
                </template>
                <template #form>
                    <div class="mt-10">
                        <jet-input-error :message="form.error('operating_limits')" class="mt-2"/>
                        <div
                        class="grid gap-1" :class="(!isDisabled('quantity',  key.split('-')[0])?(!isDisabled('value_max', key.split('-')[0])?'grid-cols-5':'grid-cols-4'):'grid-cols-4')">
                            <div class="">
                                <jet-label value="Períodos"/>
                            </div>
                            <div
                                v-if="!isDisabled('quantity', key.split('-')[0])"
                                class="">
                                <jet-label value="Quantidade"/>
                            </div>
                            <div v-if="key.split('-')[0] !== 'boleto'"
                                class="" >
                                <jet-label value="Limite por operação (R$)" />
                            </div>
                            <div
                                class="">
                                <jet-label value="Limite Máximo (R$)"/>
                            </div>

                            <div
                                v-if="!isDisabled('value_min', key.split('-')[0])"
                                class="">
                                <jet-label value="Valor Mínimo (R$)"/>
                            </div>
                            <div
                                v-if="!isDisabled('value_max', key.split('-')[0])"
                                class="">
                                <jet-label value="Valor Máximo (R$)"/>
                            </div>
                        </div>
                    </div>

                    <div
                        v-for="(item,i) in limit" v-bind:key="i"
                        class="grid gap-1 mb-4" :class="(!isDisabled('quantity', item.type.id)?(!isDisabled('value_max', item.type.id)?'grid-cols-5':'grid-cols-4'):'grid-cols-4')">
                        <div class="">
                            <div class="py-3 capitalize">
                                {{ intervals[item.interval.id] }}
                            </div>
                        </div>
                        <div
                            v-if="!isDisabled('quantity', item.type.id)"
                            class="">
                            <jet-decimal id="form.other_ownership" min='0'
                                         :precision="0"
                                         @input="forcePositive(item.quantity,i,key,limit)"
                                         class="mt-1 block text-right w-full"  :class="getClassByValueGlobal(key.split('-')[0],item.interval.id)" v-model="item.quantity"/>
                            <p v-show=false class="text-sm text-green-600">Valor Global {{ getValueGlobal(key.split('-')[0],item.interval.id) }}</p>
                        </div>
                         <div
                            v-if="item.type.id !== 'boleto'"
                            class="" >
                            <jet-decimal
                                v-if="!isDisabled('single', item.interval.id)"
                                type="text" class="mt-1 block w-full"  :class="getClassByValueGlobal(key.split('-')[0],item.interval.id)"
                                v-model="item.single"/>
                            <p  v-if="!isDisabled('single', item.interval.id)" v-show=false class="text-sm text-green-600">Valor Global {{ getValueGlobal(key.split('-')[0],item.interval.id) }}</p>
                        </div>
                        <div
                            class="">
                            <jet-decimal type="text" class="mt-1 block w-full"  :class="getClassByValueGlobal(key.split('-')[0],item.interval.id)"
                                         v-model="item.total"/>
                            <p v-show=false class="text-sm text-green-600">Valor Global {{ getValueGlobal(key.split('-')[0],item.interval.id) }}</p>

                        </div>

                        <div
                            v-if="!isDisabled('value_min', item.type.id)"
                            class="">
                            <jet-decimal
                                v-if="!isDisabled('value_min', item.interval.id)"
                                type="text"
                                class="mt-1 block w-full"  :class="getClassByValueGlobal(key.split('-')[0],item.interval.id)" v-model="item.value_min"/>
                                <p  v-if="!isDisabled('value_min', item.interval.id)" v-show=false class="text-sm text-green-600">Valor Global {{ getValueGlobal(key.split('-')[0],item.interval.id) }}</p>
                        </div>
                        <div
                            v-if="!isDisabled('value_max', item.type.id)"
                            class="">
                            <jet-decimal
                                v-if="!isDisabled('value_min', item.interval.id)"
                                type="text" class="mt-1 block w-full" :class="getClassByValueGlobal(key.split('-')[0],item.interval.id)"
                                v-model="item.value_max"/>
                                <p v-if="!isDisabled('value_min', item.interval.id)" v-show=false class="text-sm text-green-600" >Valor Global {{ getValueGlobal(key.split('-')[0],item.interval.id) }}</p>
                        </div>

                    </div>
                    <jet-input-error :message="errorMessage(key)" class="mt-2"/>
                </template>
            </jet-form-section>
        </div>
    </div>
</template>

<script>

import JetLabel from '../../Jetstream/Label';
import JetDecimal from "../../Jetstream/Decimal";
import JetFormSection from "../../Jetstream/FormSection";
import JetInput from '../../Jetstream/Input';
import JetInputError from '../../Jetstream/InputError';

export default {
    props: ['form','formError','user_index'],
    data() {
        return {
            limitDefault:{},
            erro:{},
            types: {
                'payments': 'Pagamento de Boletos',
                'ted': 'TED',
                'pix': 'PIX',
                'boleto': 'Registro de Boletos',
                'cash_in': 'CashIn',
            },
            intervals: {
                'daily': 'Diário',
                'monthly': 'Mensal',
            },
            rateList: [
                {id: 'ted', name: 'TED'},
                {id: 'pix', name: 'PIX'},
                {id: 'boleto', name: 'Registro de Boletos'},
                {id: 'boleto_payment', name: 'Boleto compensação'},
            ],
            typesList: [
                {id: 'ted', name: 'TED'},
                {id: 'pix', name: 'PIX'},
                {id: 'payments', name: 'Pagamentos'},
            ],
            intervalsList: [
                {id: 'daily', name: 'Diário'},
                {id: 'monthly', name: 'Mensal'},
            ],
        }
    },
    methods: {
        errorMessage(key){
            if (Array.isArray(this.formError[key])){
                if (this.formError[key][0] != null){
                    this.$nextTick(() => {
                        document.querySelector('#'+key).scrollIntoView({block: "center", behavior: 'smooth'});
                    });
                }
                let errorMsgs = [];
                this.formError[key].forEach(element => {
                    errorMsgs.push(element);
                });
                return errorMsgs.join('<br>');
            }
            if (this.formError[key] != null)
                return this.formError[key];
        },
        getClassByValueGlobal(type,interval){
            // return 'bg-red-200';
            return '';
        },
        getValueGlobal(type,interval){
            let array = this.limitDefault;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];

            }
            return '0,00';
        },
        isDisabled(field, type) {
            switch (field) {
                case 'quantity':
                    return (['cash_in'].includes(type));
                case 'value_min':
                case 'value_max':
                    return (['cash_in', 'ted', 'pix', 'payments', 'monthly'].includes(type));
                case 'single':
                    return type === 'monthly';
            }
            return true;
        },
        forcePositive(val, i, key,limit) {
            val = parseInt(val);
            if (val < 0) {
                 this.form.limits[key][i].quantity = 0;
            }
        },

    },
    components: {
        JetLabel,
        JetDecimal,
        JetFormSection,
        JetInputError,
        JetInput
    }
}
</script>
